<script setup>
import { computed } from 'vue'

import { cookies, privacy } from '@/routes/legal'

const currentYear = computed(() => new Date().getFullYear())

const navColumns = [
    {
        title: 'Služby',
        links: [
            { label: 'Digitálně i klasicky', href: '/#services' },
            { label: 'Garantovaná správnost', href: '/#services' },
            { label: 'Individuální péče', href: '/#services' },
        ],
    },
    {
        title: 'Společnost',
        links: [
            { label: 'O mně', href: '/#about' },
            { label: 'Jak spolupracujeme', href: '/#process' },
            { label: 'Blogy', href: '/blog' },
            { label: 'Kontakt', href: '/#contact' },
        ],
    },
]
</script>

<template>
    <footer class="border-t border-zinc-200 bg-white">
        <div class="mx-auto max-w-7xl px-6 py-14 lg:px-10">
            <div class="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
                <div class="lg:col-span-2">
                    <a
                        class="text-brand-900 flex items-center gap-3"
                        href="/"
                    >
                        <span
                            class="bg-brand-900 grid size-9 grid-cols-2 grid-rows-2 gap-px overflow-hidden rounded-md p-1"
                            aria-hidden="true"
                        >
                            <span class="bg-white" />
                            <span class="bg-transparent" />
                            <span class="bg-transparent" />
                            <span class="bg-white" />
                        </span>
                        <span class="text-xl font-bold tracking-tight">SolveCount</span>
                    </a>

                    <p class="mt-4 max-w-md text-sm text-zinc-600">
                        Účetní pro podnikatele a malé i střední firmy. Pomáháme vám rozumět vašim číslům.
                    </p>

                    <address class="mt-6 space-y-1 text-sm text-zinc-600 not-italic">
                        <p class="text-brand-900 font-semibold">SolveCount s.r.o.</p>

                        <p>Kurzova 2222/16, Stodůlky</p>

                        <p>155 00 Praha 5</p>

                        <p>IČO: 22547070</p>
                    </address>

                    <dl class="mt-6 space-y-3 text-sm">
                        <div class="flex gap-2">
                            <dt class="w-24 shrink-0 text-zinc-500">E-mail</dt>
                            <dd>
                                <a
                                    class="text-brand-900 font-medium underline-offset-4 hover:underline"
                                    href="mailto:solvecount@gmail.com"
                                >
                                    solvecount@gmail.com
                                </a>
                            </dd>
                        </div>

                        <div class="flex gap-2">
                            <dt class="w-24 shrink-0 text-zinc-500">Odezva</dt>
                            <dd class="text-zinc-600">Do 24 hodin v pracovní dny</dd>
                        </div>
                    </dl>
                </div>

                <div
                    v-for="column in navColumns"
                    :key="column.title"
                >
                    <h3 class="text-xs font-semibold tracking-wider text-zinc-500 uppercase">
                        {{ column.title }}
                    </h3>

                    <ul class="mt-4 space-y-2">
                        <li
                            v-for="link in column.links"
                            :key="link.label"
                        >
                            <a
                                class="text-brand-900 hover:text-brand-700 text-sm font-medium transition-colors"
                                :href="link.href"
                            >
                                {{ link.label }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div
                class="mt-12 flex flex-col items-start justify-between gap-3 border-t border-zinc-200 pt-6 text-sm text-zinc-500 md:flex-row md:items-center"
            >
                <p>&copy; {{ currentYear }} SolveCount s.r.o. Všechna práva vyhrazena.</p>

                <div class="flex gap-5">
                    <Link
                        class="hover:text-brand-700 transition-colors"
                        :href="privacy().url"
                    >
                        Ochrana soukromí
                    </Link>

                    <Link
                        class="hover:text-brand-700 transition-colors"
                        :href="cookies().url"
                    >
                        Cookies
                    </Link>
                </div>
            </div>
        </div>
    </footer>
</template>
